import React, { ReactNode } from 'react';
import { BlockContentContext } from '../BlockContent.utils';
import { BulletListWrapper, CheckListWrapper, CloseListWrapper, NumberListWrapper } from './ListWrapper';

/** Portable Text's `list` group: one renderer per `listItem` style. */
export const list = (context: BlockContentContext = BlockContentContext.Stripped) => ({
  bullet: ({ children }: { children?: ReactNode }) => (
    <BulletListWrapper context={context}>{children}</BulletListWrapper>
  ),
  number: ({ children }: { children?: ReactNode }) => (
    <NumberListWrapper context={context}>{children}</NumberListWrapper>
  ),
  check: ({ children }: { children?: ReactNode }) => <CheckListWrapper context={context}>{children}</CheckListWrapper>,
  close: ({ children }: { children?: ReactNode }) => <CloseListWrapper context={context}>{children}</CloseListWrapper>,
});
